import EventEmitter from "eventemitter3";
import { DISPLAY_MODAL, HIDE_MODAL } from "./ModalEvents";
import { DISPLAY_UI, FORCE_UI, HIDE_UI } from './UIEvents'

const eventEmitter = new EventEmitter();

const Emitter = {
  on: (event, fn) => eventEmitter.on(event, fn),
  once: (event, fn) => eventEmitter.once(event, fn),
  off: (event, fn) => eventEmitter.off(event, fn),
  emit: (event, payload) => eventEmitter.emit(event, payload),
};

Object.freeze(Emitter);
export default Emitter;
export { DISPLAY_MODAL, HIDE_MODAL } from "./ModalEvents";

export const MODAL_CLOSE_TYPE = {
  HOME: "home",
  BACK: "back",
  HIDE: "hide",
};

export const displayModal = (modalType = "all", closeType = MODAL_CLOSE_TYPE.HIDE) => {
  eventEmitter.emit(DISPLAY_MODAL, { modalType, closeType });
};

export const hideModal = (modalType = "all") => {
  eventEmitter.emit(HIDE_MODAL, modalType);
};

export const forceUI = (value) => {
  eventEmitter.emit(FORCE_UI, value);
}

export const displayUI = () => {
  eventEmitter.emit(DISPLAY_UI);
};

export const hideUI = () => {
  eventEmitter.emit(HIDE_UI);
};
